export default function triggerSizeChartModal() {
    if ($('#sizeChartModal').length === 0) return;
    $('#sizeChartModal').on('show.bs.modal', (e) => {
        const $triggerButton = $(e.relatedTarget);
        const $modal = $(e.currentTarget);
        const sizeChartUrl = $triggerButton.data('size-chart-url');
        const $modalBody = $modal.find('.modal-body');
        if ($modalBody.length > 0 && sizeChartUrl) {
            $.ajax({
                url: sizeChartUrl,
                type: 'get',
                dataType: 'json',
                success(data) {
                    $modalBody.html(data.content);
                },
            });
        }
    });
}
